import ViewListIcon from '@mui/icons-material/ViewList';
import { InternalStandardProps } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';
import { linkToList } from '../../../crud-core/utils/Link';
import { Resource } from '../../../crud-graphql-containers/Utils/genericTypes';
import LinkButton from '../LinkButton';
import { useStyles } from './styles';

export type ListButtonProps = {
  buttonProps?: ButtonProps;
  buttonLabel?: string;
  resourceConfig?: Resource;
} & InternalStandardProps<React.HTMLAttributes<HTMLButtonElement>>;

const ListButton: React.FC<ListButtonProps> = ({
  buttonProps,
  className,
  buttonLabel = 'List',
  resourceConfig,
  style,
}: ListButtonProps) => {
  const classes = useStyles();
  const props = {
    component: Link as any,
    icon: <ViewListIcon className={classes.listIcon} />,
    to: resourceConfig ? linkToList(resourceConfig) : '',
    buttonLabel,
    buttonProps,
  };
  return <LinkButton {...props} className={className} style={style} />;
};

// eslint-disable-next-line import/no-default-export
export default ListButton;
